import MonitoringPhaseCard from '@features/monitoringOffer/components/Card/MonitoringPhaseCard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary } from './StyledAccordion';

export default function MonitoringPhases({ phases, reports = [] }: any) {
	const { t } = useTranslation();
	const [expanded, setExpanded] = React.useState<string | false>('');

	// Handle both possible data structures
	const completedPhases = phases?.complete || phases?.completed || [];
	const upcomingPhases = phases?.upcoming || [];

	const phaseData = [
		{
			id: 'completed_phases',
			icon: CheckCircleIcon,
			title: 'completedPhases',
			phases: completedPhases,
		},
		{
			id: 'upcoming_phases',
			icon: AccessTimeIcon,
			title: 'upcomingPhases',
			phases: upcomingPhases,
		}
	];

	const handleChange = (panel: string) => (_event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpanded(newExpanded ? panel : false);
	};

	return (
		<div>
			{phaseData.map((data) => (
				<Accordion key={data.id} expanded={expanded === data.id} onChange={handleChange(data.id)}>
					<AccordionSummary aria-controls={`${data.id}-content`} id={`${data.id}-header`}>
						<div className="flex items-center">
							<Typography component="span">{t(data.title)}</Typography>
							{data.icon && (
								<data.icon
									sx={{
										marginLeft: 1,
										fontSize: '24px',
										color: data.id === 'completed_phases' ? '#00AB89' : '#7B809A',
									}}
								/>
							)}
						</div>
					</AccordionSummary>
					<AccordionDetails className="gap-3 flex flex-col">
						{data?.phases?.length > 0 ? (
							data?.phases.map((phase: any, index: any) => (
								<MonitoringPhaseCard
									key={index}
									data={phase}
									status={data.id === 'completed_phases' ? 'completed' : 'upcoming'}
									reports={reports}
								/>
							))
						) : (
							<Typography>{t('noPhasesAvailable')}</Typography>
						)}
					</AccordionDetails>
				</Accordion>
			))}
		</div>
	);
}
